import React from 'react';

import Markup from '../../markup';

type ToogleType = {
  items: string[] | { [key: string]: string | boolean },
  titles?: { [key: string]: string },
  small?: boolean,
  circle?: boolean,
  privewCircle?: boolean,
  setActive: Function, 
  active: string, 
  compact?: boolean
}

function Toggle({ items, titles, circle,privewCircle, small, setActive, active, compact = false }: ToogleType) {

  return (
    <>
      <Markup.Global.Toggle.Container compact={compact} style={{ width: circle ? 'auto' : '100%'}}>
        {
          (Array.isArray(items) ? items : Object.keys(items)).map(item => {
            if(!Array.isArray(items) && !items[item]) return;
            if(circle){
              return(<Markup.Global.Toggle.ItemCircle key={item} active={active === item} onClick={() => setActive(item)}>
                {items[item] ?? item}
            </Markup.Global.Toggle.ItemCircle>)
            }
            else if(privewCircle){
              return (<Markup.Global.Toggle.ItemSizePreview key={item} preview={'https://testravenstage.s3.eu-west-2.amazonaws.com/2023/10/temp_project-member_back_0515a9aa18ed52f9f4d0fa9ba5796f06.png'} active={active === item} onClick={() => setActive(item)}>
                    {items[item] ?? item}
                    </Markup.Global.Toggle.ItemSizePreview>)
            }
            else{
              return(<Markup.Global.Toggle.Item compact={compact} key={item} small={small} active={active === item} onClick={() => setActive(item)}>
                {titles ? titles[item] : items[item] ?? item}
            </Markup.Global.Toggle.Item>) }
          })
        }
      </Markup.Global.Toggle.Container>
    </>
  );
}

export default React.memo(Toggle);
